import getTimeline from '@api/routes/timeline-api/getTimeline';
import * as templates from './templates';

var Bunge = Bunge || {};

Bunge.Timeline = (function($) {
    var ui = {};

    const activeClass = '-active';
    const expandedClass = '-expanded';
    const hiddenClass = '-hidden';
    const decadeScrollerWidth = 984;
    let totalScroll = 0;

    function cacheUI() {
      ui.$pageTitle = $('[data-region="timelinePageTitle"]');
      ui.$timelineWrapper = $('[data-region="timelineWrapper"]');
      ui.$navPrev = $('[data-region="navPrev"]');
      ui.$navNext = $('[data-region="navNext"]');
      ui.loader = $('[data-control="pageLoader"]');
      ui.$decades = $('[data-region="decades"]');
      ui.$decadeScroller = $('[data-region="decades-scroller"]');
      ui.$decadesContainer = $('[data-region="decades"]');
      ui.apiurl = ui.$timelineWrapper.attr('data-apiurl') || ui.apiurl;
    }

    function reCacheUI() {
      ui.$decadesItems = $('[data-region="decades"]');
      ui.$events = $('[data-region="timelineWrapper"]').find('[data-region="timelineEvent"]');
    }

    function bindEvents() {
      ui.$decadesItems = ui.$decades.find('[data-region="timelineDecade"]');

      ui.$decadesItems.find('[data-region="decadeToggle"]').on('click', (e) => {
        e.preventDefault();
        handleDecadeToggleClick(e);
      });

      ui.$decadesItems.find('[data-region="eventsYear"]').on('click', (e) => {
        e.preventDefault();
        handleEventClick(e);
      });

      ui.$navPrev.on('click', (e) => {
        e.preventDefault();
        handleNavClick(e);
      });

      ui.$navNext.on('click', (e) => {
        e.preventDefault();
        handleNavClick(e);
      });
    }

    function handleNavClick(e) {
      const $navIndex = parseInt($(e.currentTarget).data('index'));
      selectEvent($navIndex);
      const $currIndex = ui.$decades.find(`.${activeClass}`).length > 0 ? parseInt(ui.$decades.find(`.${activeClass}`).data('index')) : 0;
    }

    function updateNavVisibility() {
      if(ui.$navPrev.data('index') < 0) {
        ui.$navPrev.addClass(hiddenClass);
      } else {
        ui.$navPrev.removeClass(hiddenClass);
      }

      if(ui.$navNext.data('index') >= ui.$events.length) {
        ui.$navNext.addClass(hiddenClass);
      } else {
        ui.$navNext.removeClass(hiddenClass);
      }
    }

    function updateNavIndexes(currIndex) {
      ui.$navPrev.data('index', currIndex - 1);
      ui.$navNext.data('index', currIndex + 1);
    }

    function handleDecadeToggleClick(e) {
      const $currDecade = $(e.currentTarget).parent();

      $currDecade.toggleClass(expandedClass);

      if($currDecade.hasClass(expandedClass)) {
        $currDecade.siblings().removeClass(expandedClass);
      }

      const $decadeFirstEvent = $currDecade.find('.events').children(':first-child').data('index');
      selectEvent($decadeFirstEvent);
    }

    function handleEventClick(e) {
      const $currIndex = parseInt($(e.currentTarget)[0].dataset.index);
      selectEvent($currIndex);
    }

    function selectEvent(index) {
      const $selectedEvent = ui.$decadesItems.find(`[data-index="${index}"`);
      const $selectedEventDecade = $selectedEvent.parents('[data-region="timelineDecade"]');
      
      ui.$decadesItems.find('[data-region="timelineDecade"]').removeClass(expandedClass);
      ui.$decadesItems.find('[data-region="eventsYear"]').removeClass(activeClass);
      $selectedEvent.addClass(activeClass);
      
      if(ui.$decadeScroller.width() < decadeScrollerWidth) {
        setTimeout(() => {
          const scrollerHalf = ui.$decadeScroller.width()/2;
          const containerOffset = ui.$decadesContainer.offset().left;
          const eventOffset = $selectedEvent.offset().left;

          if(eventOffset > scrollerHalf) {
            const scrollAmount = scrollerHalf - eventOffset;
            totalScroll = totalScroll + scrollAmount;
            ui.$decadesContainer.attr('style', `transform: translateX(${totalScroll}px)`);
          }

          if(eventOffset < scrollerHalf && containerOffset < 0) {
            const scrollAmount = scrollerHalf - eventOffset;
            totalScroll = totalScroll + scrollAmount;
            if(totalScroll > 0) {
              totalScroll = 0;
            }
            ui.$decadesContainer.attr('style', `transform: translateX(${totalScroll}px)`);
          }
        }, 300);
      }

      $selectedEventDecade.siblings().removeClass(expandedClass);
      $selectedEventDecade.addClass(expandedClass);

      scrollTimeline(index);

      updateNavIndexes(index);
      updateNavVisibility();
    }

    function scrollTimeline(index) {
      ui.$timelineWrapper.attr('style', `transform: translateX(-${index * 100}%)`);
    }

    function showLoader() {
      ui.$timelineWrapper.css('opacity', '.3').css('pointer-events', 'none');
      ui.loader.show();
    }

    function hideLoader() {
      ui.$timelineWrapper.css('opacity', '1').css('pointer-events', 'all');
      ui.loader.hide();
    }

    async function fetchTimeline() {
      let url = ui.apiurl;
      if (process.env.NODE_ENV !== 'development') {
        getTimeline.setRoute(url);
      }

      const { success, data, error } = await getTimeline.query();
      if (!success) {
        console.log('failed', error);
        hideLoader();
        return;
      }

      ui.$pageTitle.html(data.title);
      const timelineResults = data.results;
      const decades = {};

      $.each(timelineResults, (i, item) => {
        const decade = Math.floor(item.startYear / 10) * 10;
        
        if(!decades[decade]) {
          decades[decade] = [];
        }

        decades[decade].push({
          index: i,
          phase: item.phase,
          startYear: item.startYear,
          endYear: item.endYear,
          displayYear: item.displayYear,
          description: item.description,
          image: item.image
        });

        ui.$timelineWrapper.append(`${templates.eventSlide({
          index: i,
          eventItem: item
        })}`);
      });

      let timelineDecade = '';
      for (const [key, value] of Object.entries(decades)) {
        timelineDecade += `${templates.decadeItem({
          decade: key,
          decadeItems: decades[key]
        })}`;
      }

      ui.$decades.html(timelineDecade);

      reCacheUI();
      bindEvents();
      selectEvent(0);
      hideLoader();
    }

    function init() {
      if ($('[data-region="timelineWrapper"]').length <= 0) {
        return;
      }
      cacheUI();
      showLoader();
      fetchTimeline();
    }

    return {
      init: init
    };
})(jQuery);

$(function() {
    Bunge.Timeline.init();
});